import React from 'react';
import { createRoot } from 'react-dom/client';
import FaqTabs from './components/FaqTabs.jsx';
import './styles/faqs.css';

const parseBooleanAttr = (value, defaultValue = true) => {
  if (value == null) return defaultValue;
  const normalized = value.toString().trim().toLowerCase();
  if (['false', '0', 'no', 'off'].includes(normalized)) return false;
  if (['true', '1', 'yes', 'on'].includes(normalized)) return true;
  return defaultValue;
};

const parseNumberAttr = (value, defaultValue) => {
  if (value == null) return defaultValue;
  const n = parseInt(value, 10);
  return Number.isNaN(n) || n <= 0 ? defaultValue : n;
  };

class SCLFaqsElement extends HTMLElement {
  connectedCallback() {
    this._root = createRoot(this);
    this._schemaScriptId =
      this.getAttribute('schema-script-id') ||
      `scl-faqs-jsonld-${Math.random().toString(36).slice(2)}`;

    const name = this.getAttribute('name') || 'FAQ';
    const categories = this.getAttribute('categories') || '';
    const vacabularyName =
      this.getAttribute('vacabulary-name') || 'FAQ';

    // New props
    const limitAttr = this.getAttribute('limit');
    const isViewAllAttr = this.getAttribute('is-view-all-page');
    const isSearchEnableAttr = this.getAttribute('is-search-enable');

    // Backwards compatibility with initial-count/show-view-more if already used
    const legacyInitialCount = this.getAttribute('initial-count');
    const legacyShowViewMore = this.getAttribute('show-view-more');

    const limit = parseNumberAttr(
      legacyInitialCount ?? limitAttr,
      5
    );

    const isViewAllPage = parseBooleanAttr(
      isViewAllAttr ?? legacyShowViewMore,
      false
    );

    const isSearchEnable = parseBooleanAttr(
      isSearchEnableAttr,
      false
    );

    this._root.render(
      <FaqTabs
        name={name}
        categories={categories}
        vacabularyName={vacabularyName}
        limit={limit}
        isViewAllPage={isViewAllPage}
        isSearchEnable={isSearchEnable}
        schemaScriptId={this._schemaScriptId}
      />
    );
  }

  disconnectedCallback() {
    document.getElementById(this._schemaScriptId)?.remove();
    this._root?.unmount();
  }
}

if (!customElements.get('scl-faqs')) {
  customElements.define('scl-faqs', SCLFaqsElement);
}

